import _ from 'lodash';

export const ACTIVATE_EXTRA_CART_ELEMENT = 'ACTIVATE_EXTRA_CART_ELEMENT';
export const SHOW_MODAL_CART_ELEMENT = 'SHOW_MODAL_CART_ELEMENT';
export const ADD_ITEM_SHOPPING_CART = 'ADD_ITEM_SHOPPING_CART';
export const REMOVE_ITEM_SHOPPING_CART = 'REMOVE_ITEM_SHOPPING_CART';
export const LOAD_ITEMS_SHOPPING_CART = 'LOAD_ITEMS_SHOPPING_CART';
export const ADD_OBSERVATIONS_TO_CARTITEM = 'ADD_OBSERVATIONS_TO_CARTITEM';
export const CLEAN_SHOPPING_CART_STORE = 'CLEAN_SHOPPING_CART_STORE';
export const CHANGE_CLIENT_CHARGE_SERVICE_SUCCESS = 'CHANGE_CLIENT_CHARGE_SERVICE_SUCCESS';
export const TOGGLE_ADDITIONAL_SERVICE = 'TOGGLE_ADDITIONAL_SERVICE';
export const MAIN_SERVICE_KM = 'MAIN_SERVICE_KM';
export const SET_LIMIT_APPOINTMENT_DATE = 'SET_LIMIT_APPOINTMENT_DATE';
export const LOAD_INITIALS_DATEPICKERUI_VALUES = 'LOAD_INITIALS_DATEPICKERUI_VALUES';
export const ADD_REPLACEMENT_VEHICLE = 'ADD_REPLACEMENT_VEHICLE';
export const REMOVE_REPLACEMENT_VEHICLE = 'REMOVE_REPLACEMENT_VEHICLE';

const IVA = 1.21;

export function activateExtra(extra) {
  return dispatch => {
    dispatch({
      type: ACTIVATE_EXTRA_CART_ELEMENT,
      payload: {
        extra,
      },
    })
  }
}

export function showModal(isVisible, content = null) {
  return dispatch => {
    dispatch({
      type: SHOW_MODAL_CART_ELEMENT,
      payload: {
        show: isVisible,
        content,
      },
    })
  }
}

export function addToCart(item, makeObjectParam, car) {

  const engineId = car.engineId
                  ? car.engineId
                  : (car.carEngine.split(",")[2])

  return dispatch => {
    let carService;

    if (item && Array.isArray(item.cars) && item.cars.length > 0) {
      carService = _.find(item.cars, e => {
        const currentYear = (new Date()).getFullYear();
        const age = currentYear - car.carYear;
        // Filters
        const isIncluded = _.includes(e.references, engineId)
        const ageMin = !Number.isNaN(age) && age >= e.from;
        const ageMax = e.to ? !Number.isNaN(age) && age <= e.to : true //Default to true if to is null

        return isIncluded && ageMin && ageMax
      });
    }

    dispatch({
      type: MAIN_SERVICE_KM,
      payload: {
        mainServiceKm: false
      }
    })

    dispatch({
      type: ADD_ITEM_SHOPPING_CART,
      payload: {
        item: {
          ...item,
          acceptedBubocar: !!carService || !!(item.price !== null && item.price !== undefined), //added in noForfait flow
          acceptedClient: !!carService || !!(item.price !== null && item.price !== undefined) || null,
          // NOTE: I don't check if carService.price is null below because, if it's null, we "can't" add the service to the shopping car ~ D. Sánchez (11/04/2018)
          price: carService && carService.price ? carService.price : item.price ? Number(parseFloat(item.price.toFixed(2))) : item.price, //TODO: CHECK ALSO THE AGE
          originalPrice: item.price ? Number(parseFloat(item.price.toFixed(2))) : item.price,
          ivaPrice: carService && (carService.price !== null && carService.price !== undefined) ? Number(parseFloat(carService.price * IVA).toFixed(2)) : item.price ? Number.parseFloat((item.price * IVA).toFixed(2)) : item.price,
          // We may want to add noForfait bool property here in the future ~ A. Salcedo (10/04/2018)
        },
      },
    })
  }
};

export function addObservationsToCartItem(item, observations) {
  return dispatch => {
    dispatch({
      type: ADD_OBSERVATIONS_TO_CARTITEM,
      payload: {
        item,
        observations,
      },
    })
  }
};

export function removeFromCart(index, serviceId) {
    return dispatch => {
        dispatch({
            type: REMOVE_ITEM_SHOPPING_CART,
            payload: {
                index,
                serviceId,
            },
        })
    }
}

export function cleanShoppingCartStore(props) {
  return dispatch => {
    dispatch({
      type: CLEAN_SHOPPING_CART_STORE,
      payload: {
        props,
      }
    })
  }
}

export function setLimitDateAppointment(hour) {
  return dispatch => {
    dispatch({
      type: SET_LIMIT_APPOINTMENT_DATE,
      payload: {
        tempHoursRange: hour,
      }
    })
  }
}

export function loadInitialsDatePickerValues() {
  return dispatch => {
    dispatch({
      type: LOAD_INITIALS_DATEPICKERUI_VALUES
    })
  }
}

export function addReplacementVehicle() {
  return dispatch => {
    dispatch({
      type: ADD_REPLACEMENT_VEHICLE
    })
  }
}

export function removeReplacementVehicle() {
  return dispatch => {
    dispatch({
      type: REMOVE_REPLACEMENT_VEHICLE
    })
  }
}

export function noChargeServiceNewAppointment(index, { whoPays }) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_CLIENT_CHARGE_SERVICE_SUCCESS,
      payload: {
        index,
        whoPays,
      }
    })
  }
}

export function toggleAdditionalService(additionalService) {
  return dispatch => {
    dispatch({
      type: TOGGLE_ADDITIONAL_SERVICE,
      payload: {
        additionalService: {
          ...additionalService,
          ivaPrice: Number(parseFloat(additionalService.price * 1.21).toFixed(2))
        }
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/shoppingCart/actions.js